export default __webpack_public_path__ + "static/media/claveunica.f53cf24e.svg";